import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { MatSnackBar } from "@angular/material/snack-bar";

import { VehiclesHandlerService } from "../../api-handlers/vehicles-handler.service";

@Component({
  selector: "edit-brand-modal",
  templateUrl: "./edit-brand-modal.component.html",
})
export class EditBrandModalComponent implements OnInit {
  brandId?: string;
  name?: string;
  closed_at?: string;

  activeChecked: boolean;
  didUserEdit = false;
  errorMessage = "";
  isLoading = false;

  constructor(
    public bsModalRef: BsModalRef,
    private snackBar: MatSnackBar,
    private vehiclesService: VehiclesHandlerService
  ) {}

  ngOnInit() {
    this.activeChecked = this.closed_at === "0";
  }

  async onEditClick() {
    this.isLoading = true;

    try {
      const updateBrandBody = {
        vbr_id: this.brandId,
        vbr_name: this.name,
        vbr_closed: this.activeChecked ? 0 : 1,
      };

      await this.vehiclesService.adminUpdateBrand(updateBrandBody);

      this.bsModalRef.hide();
      this.snackBar.open(`Marca "${this.name}" modificata`, undefined, {
        duration: 3000,
      });
    } catch (error) {
      this.errorMessage = error.message;
    } finally {
      this.isLoading = false;
    }
  }
}
